import React from "react";

import { motion } from "framer-motion";
import { iconVariants } from "../../utils/motionVariants";

const SocialIcon = ({ link, icon, newTab = true }) => {
  return (
    <motion.a
      className="social-icons motion-effect m-1"
      href={link}
      target={newTab ? "_blank" : "_self"}
      rel="noreferrer noopener"
      variants={iconVariants}
      whileHover="hover"
      whileTap="click"
    >
      {icon}
    </motion.a>
  );
};

export default SocialIcon;
